

import Vue from 'vue'

let models = require.context('../filter', false, /\.js$/);

models.keys().forEach(item => {
    let startNum = item.indexOf("/")+1,
        endNum = item.lastIndexOf("."),
        name = item.slice(startNum,endNum);
        if(name != "index") Vue.filter(name,models(item).default);
})


// WEBPACK FOOTER //
// ./src/filter/index.js